import Vue from 'vue'
import VueEvents from 'vue-events'
import VueDatetime from 'vue-datetime'

export default function () {
  Vue.use(VueEvents)
  Vue.use(VueDatetime)
}